package ru.villawonka.app.common.extensions

import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.ui.Modifier
import ru.villawonka.app.getTelegram

fun Modifier.applyTelegramBottomInset(): Modifier =
    getTelegram()?.getSafeAreaInset()?.let { insets ->
        windowInsetsPadding(
            insets = WindowInsets(
                bottom = insets.bottom
            )
        )
    } ?: this